export default {
    modal_move: {
        status: 'Mover Status - {{title}}',
        task: 'Mover Tarea - {{title}}',
        all_tasks: 'Mover Todas las Tareas con Estado - {{title}}'
    },
    error: {
        move_tasks: 'No se pudieron mover las siguientes tareas',
        archive_tasks: 'No se pudieron archivar las siguientes tareas',
    },
    alert: {
        archive_all_tasks_title: '¿Quieres archivar todas las tareas con status {{status}}?',
        archive_all_tasks_text: 'Después de archivar las tareas, ya no será posible actualizarlas.',
    },
}
